<template>
  <div class="main-page scrollbar ">
    <h1>Add Credit Balance</h1>

    <TopUpCreditCard/>
    <TopUpCoupon/>
    <TopUpEmail/>
  </div>

</template>

<script>
import TopUpCoupon from './ClaimCoupon.vue';
import  TopUpCreditCard from './CreditCardFunds.vue';
import TopUpEmail from './EmailRequestFunds.vue';

export default {

  components: {
    TopUpCreditCard,
    TopUpCoupon,
    TopUpEmail,
  },
  data() {
  
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
    isAdmin() {
      return this.user && (this.user.role === 'admin');
    },
    isSuper() {
      return this.user && (this.user.role === 'super');
    },
  },
  async created() {
    if (!this.isAdmin && !this.isSuper) {
      this.$router.push({ path: '/login' });
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.main-page {
  height: 100%;
  overflow-y: auto;
  margin:30px;
}

</style>
